import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "../../components/CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

import { CssBaseline } from "@material-ui/core";


import ConfirmationDialog from "../ConfirmationDialog";
import { setTemplate } from "../../redux/slices/templateSlice";
import TableStatus from "../TableStatus";

const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      width: "100%",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const Templates = ({ selectedOption, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const locationData = useSelector((state) => state.location);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);

  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [currentHtmlContent, setCurrentHtmlContent] = useState("");
  const templateData = useSelector((state) => state?.template);
  const templates = templateData?.template;
  const [maker, setMaker] = useState("");
  const handleViewTemplate = (htmlContent) => {
    setCurrentHtmlContent(htmlContent || "<div>No Content Available</div>");
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setCurrentHtmlContent("");
  };

  const columns = [
    {
      field: "name",
      headerName: "Template Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "Maker",
      headerName: "Maker",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return params?.row?.customProperties?.contentAiTemplateMaker;
      },
    },
    {
      field: "image",
      headerName: "Image",
      minWidth: 120,
      flex: 2,
      renderCell: (params) => {
        const imageUrl = params?.row?.imageUrl ? params?.row?.imageUrl : null;

        const isVideo = imageUrl ? /\.(mp4|avi|mov)$/i.test(imageUrl) : false;

        return imageUrl ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {isVideo ? (
              <video
                controls
                style={{
                  width: "150px", 
                  height: "105px",
                  borderRadius: "10px", 
                  border: "1px solid #ccc", 
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", 
                }}
              >
                <source src={imageUrl} type="video/mp4" />
                <source src={imageUrl} type="video/avi" />
                <source src={imageUrl} type="video/mov" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={imageUrl}
                alt="Customisation"
                style={{
                  width: "150px", 
                  height: "105px", 
                  objectFit: "cover",
                  borderRadius: "10px", 
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", 
                }}
              />
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            No Media
          </div>
        );
      },
    },

    {
      field: "view",
      headerName: "View",
      flex: 1,
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          startIcon={<VisibilityIcon />}
          onClick={() =>
            handleViewTemplate(params?.row?.customProperties?.html)
          }
        >
          View
        </Button>
      ),
    },

    ,
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1.2,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => {
            handleDelete(params?.row?.id);
            setMaker(params.row.customProperties?.contentAiTemplateMaker);
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  const handleEdit = (id) => {
    setSelectedItemId(id);
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "template",
      query: { id: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== deleteItemId
          );

          dispatch(setTemplate(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (templateData.template) setRows(templateData.template);
  }, [templateData.template]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                contentAI={true}
                maker={maker}
              />
            )}
            <Dialog
              open={openViewModal}
              onClose={handleCloseViewModal}
              maxWidth="md"
              sx={{
                "& .MuiDialog-paper": {
                  width: "auto",
                  height: "auto",
                  maxWidth: "80vw",
                  maxHeight: "95vh",
                  borderRadius: "15px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                  overflow: "hidden",
                  padding: "2",
                },
              }}
            >
              <DialogActions
                sx={{
                  padding: "12px 16px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  onClick={handleCloseViewModal}
                  sx={{
                    color: "gray",
                    fontSize: "1.5rem",
                    padding: "8px",
                    "&:hover": {
                      backgroundColor: "#f0f0f0", 
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogActions>

              <DialogContent
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  overflow: "hidden",
                  alignItems: "center",
                  padding: "0", 
                }}
              >
                <iframe
                  srcDoc={currentHtmlContent} 
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none", 
                    borderRadius: "12px", 
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", 
                    backgroundColor: "#fff", 
                    overflow: "auto",
                    minHeight: "500px", 
                    minWidth: "640px", 
                  }}
                />
              </DialogContent>
            </Dialog>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default Templates;
